jQ(async function () {
    if (jQ('.DatePicker').length > 0) {
        await import('jquery-ui/ui/widgets/datepicker');
        // await import('jquery-ui/themes/base/datepicker.css');
    }
});

require('./modules/validation/validate');

var window_width = jQ(window).width(),
    det_slider = false,
    det_slider_data_mobile = false,
    rate_mobile = false,
    window_width = jQ(window).width(),
    right_col = jQ(".ad_view .col-2-content > .col-rt"),
    footer = jQ("#newfooter");

mobileDetailSlider(window_width);
ratePos(window_width);

jQ(document).ready(function () {
    if(!document.querySelector('.g-capthca-script') && window.GOOGLE_RECAPTCHA_SITE_KEY){
        var scriptElement = document.createElement('script');
        scriptElement.className = 'g-capthca-script';
        scriptElement.src = 'https://www.google.com/recaptcha/api.js?render=' + window.GOOGLE_RECAPTCHA_SITE_KEY;
        document.head.appendChild(scriptElement);
    }

    DetailCheckFavorite();
    rightOffset();

    jQ("body").on("click", "#detail_slider .slide_data, #detail_slider .start-video", function (e) {
        var elem = this;
        OpenDetailSlider(elem, post_id);
    });

    jQ('.print').click(function () {
        var styles =
            '<style type="text/css" media="print">\
                    #newfooter, .tabHeader, #header .col-3{display:none;}\
                    #header .tac.col-3{display:block;float:none;margin:0 auto;}\
                    #header{border:none;}\
                    #availabilitySection .availabilityTable .actions{display: none;}\
                    #availabilitySection .availabilityTable{border-left: none;border-right: none;}\
                    .ad_view .content{padding-top:0;}\
                    .details-title > .col-2-wrap .col-lt{width: 100%;float: none;}\
                    .details-title .distance{width: 100%;float: none;}\
                    .details-title{border:none;height:auto;}\
            \
            </style>';
        jQ('head').append(styles);
        window.print();

        return false;
    });


    jQ(window).scroll(function () {
        stickyHead();
        rightOffset();
    });

    jQ(window).resize(function () {
        window_width = jQ(window).width();

        stickyHead();
        ratePos(window_width);
        mobileDetailSlider(window_width);
    });

//                 $("div").click(function(e) {
//        if($(e.target).is('p')){
//            e.preventDefault();
//            return;
//        }
//        alert("woohoo!");
//    });
    jQ("#detail_slider_popup").click(function (e) {
        if (jQ(e.target).is('#detail_slider_popup')) {
            jQ('#detail_slider_popup .popup_close_button').click();
        }
    });

    import('./modules/slider').then(module => {
        window.UloopDetailPageSlider = new module.default({
            slider: "#detail_slider",
            wrap_big_image: ".custom_page_big_image",
            use_preview: false,
            use_control_next_prev: true,
            use_preloader: true,
            resize_width: true,
            use_align_item_full_with: true,
            big_image_show_next_slide_on_click: false
        });
        UloopDetailPageSlider.SliderInit();
    });


    import('./modules/slider').then(module => {
        window.NearbyApartmentsSlider = new module.default({
            slider: ".recent_view_slider",
            wrap_big_image: ".custom_page_big_image",
            use_preview: false,
            resize_width: true,
            stop_defaut_event: false,
            big_image_show_next_slide_on_click: false,
            image_index: ".current_photo"
        });
        NearbyApartmentsSlider.SliderInit();
    });
});


function ratePos(window_width) {
    if (window_width <= 1007 && !rate_mobile) {
        jQ(".ratingwrap.mobile").html(jQ(".ratingwrap.pc").html());
        rate_mobile = true;
    }
    else if (window_width > 1007 && rate_mobile) {
        jQ(".ratingwrap.pc").html(jQ(".ratingwrap.mobile").html());
        rate_mobile = false;
    }
}

function rightOffset() {
    if (right_col.is(":visible")) {
        var header_height_detail = 0,
            right_col_height = right_col.outerHeight(),
            footer_offset = footer.offset();

        var page_Y_offset = window.pageYOffset;

        if (!page_Y_offset) {
            if (window.document.compatMode == "CSS1Compat")
                page_Y_offset = window.document.documentElement.scrollTop;
            else
                page_Y_offset = window.document.body.scrollTop;
        }

        if(page_Y_offset > jQ('#propertyHeader').outerHeight() + 1){
            header_height_detail = jQ('#header').outerHeight() + jQ("#header-mobile-prevnext").outerHeight() + jQ(".propertyBedrooms").outerHeight() + 1;
        } else {
            header_height_detail = jQ('.propertyBedrooms').offset().top + jQ('.propertyBedrooms').outerHeight() - page_Y_offset + 2;
        }

        if (right_col.has('.popup-schedule-tour') && jQ(window).width() <= 750) {
            if (jQ(window).scrollTop() >= header_height_detail + right_col_height) {
                right_col.css({top: '0', bottom: 'unset', marginTop: 0});
                right_col.find('#reply-schedule-tour-date').removeClass('fixed_to_bottom');
            } else {
                right_col.css({top: 'unset', bottom: 0, marginTop: 0});
                right_col.find('#reply-schedule-tour-date').addClass('fixed_to_bottom');
            }
        } else {
            if (page_Y_offset + header_height_detail + right_col_height + parseInt(footer.css('marginTop')) >= footer_offset.top) {
                right_col.css({position: 'absolute', top: '100%', marginTop: - (right_col_height)});
                jQ(".details-title").css({zIndex: 40});
            } else {
                right_col.css({position: 'fixed', top: header_height_detail, marginTop: 0});
                jQ(".details-title").css({zIndex: 30});
            }
        }
    }

    if (jQ(window).width() <= 750) {
        if (typeof jQ(window).scrollTop() !== typeof undefined && jQ(window).scrollTop() > 0) {
            jQ('#contactRollupSection').addClass('ios_fix');
        } else {
            jQ('#contactRollupSection').removeClass('ios_fix');
        }
    }
}

function DetailCheckFavorite () {
    var hotlistArray = JSON.parse(localStorage.getItem('hotlistArray'))

    if (hotlistArray) {
        var l_id = ~~jQ('.hotlist').attr('l_id')
        for (var p in hotlistArray) {
            if (hotlistArray.hasOwnProperty(p)) {
                if (hotlistArray[p].listing_id == l_id) {
                    jQ('.hotlist').addClass('added').attr('title', 'Remove from Favorites')
                }
            }
        }
    }
}

function stickyHead() {
    var scroll = jQ(window).scrollTop();

    if (window_width >= 600 && scroll > 0) {
        var header_prevnext_height = jQ("#header-mobile-prevnext").outerHeight();
        if(header_prevnext_height <= 1){
            header_prevnext_height = 0;
        }
        var fix_height = jQ("#header").outerHeight() + header_prevnext_height;
        var property_bedrooms_height =
            jQ('.propertyBedrooms').outerHeight() + parseInt(jQ('.propertyBedrooms').css('marginBottom'));

        jQ('#header-mobile-prevnext').css('cssText', "position: fixed !important;");
        jQ('#header').css('cssText', "position: fixed !important; top: " + header_prevnext_height + "px");

        if(scroll > jQ('#propertyHeader').outerHeight() + 1) {
            jQ('.propertyBedrooms').css({
                position: "fixed",
                left: 0,
                right: 0,
                top: (fix_height - 1) + 'px',
                zIndex: 100
            });
            jQ(".height-fix-content").css("height", fix_height + (jQ('.propertyBedrooms').is(":visible") ? property_bedrooms_height : 0));
        } else {
            jQ('.propertyBedrooms').css({position: "initial"});
            jQ(".height-fix-content").css("height", fix_height);
        }
    } else {
        jQ('#header-mobile-prevnext').css('cssText', "position: relative !important");
        jQ('#header').css('cssText', "position: relative !important;");
        jQ('.propertyBedrooms').css({position: "initial"});
        jQ(".height-fix-content").css("height", 0);
    }
}

function mobileDetailSlider(window_width) {

    if (typeof(jQ("#detail_slider")) == 'undefined')
        return false;

    if (window_width <= 683 && !det_slider_data_mobile) {

        det_slider = jQ("#detail_slider .custom_page_big_image").clone(true);

        var mobile_det_slider = jQ("#detail_slider .custom_page_big_image");
        jQ(mobile_det_slider).html('');

        jQ('.slide_data', det_slider).each(function (index, elem) {
            var item = jQ(elem).clone().addClass('item');
            jQ(mobile_det_slider).append(item);
        });

        det_slider_data_mobile = true;
    }
    else if (window_width > 683 && det_slider_data_mobile) {
        jQ("#detail_slider .custom_page_big_image").replaceWith(det_slider);
        UloopDetailPageSlider.preloadImages(UloopDetailPageSlider.options);
        det_slider_data_mobile = false;
    }
}

function OpenDetailSlider (elem, id) {
    var type = ''
    if (jQ(elem).hasClass('ad_slide'))
        type = 'ad_slide'
    else if (jQ(elem).hasClass('ad_storage_slide'))
        type = 'ad_storage_slide'
    else if (jQ(elem).hasClass('floorplan'))
        type = 'floorplan'
    else if (jQ(elem).hasClass('video'))
        type = 'video'
    else if (jQ(elem).hasClass('3d'))
        type = '3d'

    showPreloader()

    jQ.ajax({
        url: 'index.php',
        data: 'action=getDetailPopup&id=' + ~~id + '&index=' + ~~jQ(elem).attr('data-index') + '&type=' + type,
        type: 'POST',
        success: function (data) {
            if (data)
                var data = JSON.parse(data)

            jQ('#preloader').hide()

            jQ('#detail_slider_popup .detail_slider_header .top').html(data.title)
            jQ('#detail_slider_popup #tab_content').html(data.content)

            jQ('#detail_slider_popup #detail_tabs_line li').off('click')
            jQ('#detail_slider_popup #detail_tabs_line li').click(function () {

                var video = jQ('#tab_video_content iframe')
                if (jQ(video).length) {
                    jQ(video).attr('src', '')
                }

                var tab_id = jQ(this).find('a').attr('default')

                if (tab_id == 'tab_video_content') {
                    var video = jQ('#tab_video_content iframe.control-src');
                    if (jQ(video).length) {
                        jQ(video).each(function(index,elem){
                            jQ(elem).attr('src', jQ(elem).attr('default-src'))
                        });

                    }
                }

                jQ('#detail_tabs_line li').removeClass('active')
                jQ(this).addClass('active')
//
                jQ('#detail_slider_popup #tab_content .tab').removeClass('active')
                jQ('#' + tab_id).addClass('active')

                return false
            })

            ////
            jQ('#detail_slider_popup').fadeIn(300)

        },
        complete: function () {
            if (jQ(elem).hasClass('ad_slide')) {
                jQ('#detail_slider_popup .tab#tab_photo_content').addClass('active')
            }
            else if (jQ(elem).hasClass('ad_storage_slide')) {
                jQ('#detail_slider_popup .tab#tab_photo_content').addClass('active')
            }
            else if (jQ(elem).hasClass('floorplan')) {
                jQ('#detail_slider_popup .tab#tab_floorplan_content').addClass('active')
            }
            else if (jQ(elem).hasClass('3d')) {
                jQ('#detail_slider_popup .tab#tab_3d_content').addClass('active')
            }
            else if (jQ(elem).hasClass('video') || jQ(elem).hasClass('start-video')) {
                var video = jQ('#tab_video_content iframe.control-src')
                if (jQ(video).length) {
                    // jQ(video).attr('src', jQ(video).attr('default-src'))
                    jQ(video).each(function(index,elem){
                        jQ(elem).attr('src', jQ(elem).attr('default-src'));
                    });
                }
            }

            if (!jQ('#detail_slider_popup #detail_tabs_line li.active').length) {
                jQ('#detail_slider_popup #detail_tabs_line li:first').addClass('active')
            }

            if (!jQ('#detail_slider_popup .tab.active').length) {
                jQ('#detail_slider_popup .tab:first').addClass('active')
            }

            if (jQ('#detail_slider_popup #3d_tour_slider').length) {
                import('./modules/slider').then(module => {
                    window.DetailBig3dSlider = new module.default()
                    DetailBig3dSlider.SliderInit({
                        slider: '#3d_tour_slider',
                        wrap_big_image: '.custom_page_big_image',
                        wrap_preview: '.wrap_preview',
                        resize_width: true,
                        use_preview: true,
                        use_align_item_full_with: true,
                        image_index: '#detail_current_photo',
                        is_iframe_slider: true,
                        preload_all: true,
                    });

                    if (jQ(elem).hasClass('3d')) {
                        DetailBig3dSlider.showImgByIndex(elem, DetailBig3dSlider.options, jQ(elem).attr('data-index'))
                    }
                });
            }

            if (jQ('#detail_slider_popup #property_slider').length) {
                import('./modules/slider').then(module => {
                    window.DetailBigAdsSlider = new module.default();
                    DetailBigAdsSlider.SliderInit({
                        slider: '#property_slider',
                        wrap_big_image: '.custom_page_big_image',
                        wrap_preview: '.wrap_preview',
                        resize_width: true,
                        use_preview: true,
                        use_align_item_full_with: true,
                        image_index: '#detail_current_photo',
                        preload_all: true,
                    });

                    if (jQ(elem).hasClass('ad_slide')) {
                        DetailBigAdsSlider.showImgByIndex(elem, DetailBigAdsSlider.options, jQ(elem).attr('data-index'))
                    }

                    if (jQ(elem).hasClass('ad_storage_slide')) {
                        DetailBigAdsSlider.showImgByIndex(elem, DetailBigAdsSlider.options, jQ(elem).attr('data-index'))
                    }
                });
            }

            if (jQ('#detail_slider_popup #floorplan_slider').length) {
                import('./modules/slider').then(module => {
                    window.DetailBigFloorplanSlider = new module.default()
                    DetailBigFloorplanSlider.SliderInit({
                        slider: '#floorplan_slider',
                        wrap_big_image: '.custom_page_big_image',
                        wrap_preview: '.wrap_preview',
                        resize_width: true,
                        use_preview: true,
                        use_align_item_full_with: true,
                        image_index: '#detail_current_photo',
                        preload_all: true,
                    });

                    if (jQ(elem).hasClass('floorplan')) {
                        DetailBigFloorplanSlider.showImgByIndex(elem, DetailBigFloorplanSlider.options, jQ(elem).attr('data-index'))
                    }
                });
            }

            if (jQ('#detail_slider_popup #video_slider').length) {
                import('./modules/slider').then(module => {
                    window.DetailBigVideoSlider = new module.default()
                    DetailBigVideoSlider.SliderInit({
                        slider: '#video_slider',
                        wrap_big_image: '.custom_page_big_image',
                        wrap_preview: '.wrap_preview',
                        resize_width: true,
                        use_preview: true,
                        use_align_item_full_with: true,
                        image_index: '#detail_current_photo',
                        is_iframe_slider: true,
                        preload_all: true,
                    });

                    if (jQ(elem).hasClass('video')) {
                        DetailBigVideoSlider.showImgByIndex(elem, DetailBigVideoSlider.options, jQ(elem).attr('data-index'))
                    }
                });
            }

            jQ('.popup_overlay, .loading').hide()
        }
    })
}

function deleteAd (id) {
    var URL = AJAXBaseURL + '/ajaxapi.php?delete_ad=1&ad=' + id
    dhtmlCampusAveLoadScript(URL)
    return false
}

function buildStUnit(elem, id, display, maxDate, closedDays, closedDates) {
    if (typeof maxDate === 'undefined') {
        maxDate = '';
    }
    if (typeof closedDays === 'undefined') {
        closedDays = [];
    }
    if (typeof closedDates === 'undefined') {
        closedDates = [];
    }

    var parent = jQ(elem).parents('.storage');

    if (display) {
        jQ('.reserve_form_container form input[name="spaceId"]', parent).val(id);

        jQ('.st_unit_size_table', parent).css('display', 'none');
        jQ('#desc_reserv_' + id, parent).css('display', 'block');
        jQ('.reserve_form_container', parent).css('display', 'block');

        jQ(parent).find('.DatePicker').each(function (index, element) {
            const $input = jQ(element);
            const $error = jQ(element).parent().closest('.error-message');

            // Check if this specific input has already been initialized
            if (!$input.hasClass('hasDatepicker')) {
                const randomId = Math.random().toString(36).substr(2, 9);

                $input.attr('id', randomId);
                $input.parent().addClass(randomId + '-wrap');
                $error.attr('id', randomId + '-error');

                $input.datepicker({
                    inline: true,
                    nextText: '&rarr;',
                    prevText: '&larr;',
                    showOtherMonths: true,
                    dateFormat: 'mm/dd/yy',
                    showOn: 'both',
                    buttonImageOnly: true,
                    buttonImage: 'calendar.png', // optional
                    minDate: 0,
                    onSelect: function (dateText) {
                        jQ(this).val(dateText);
                    },
                    onClose: function () {
                        // Refocus the input field after closing the datepicker
                        $input.focus();
                    },
                    beforeShow: function(input, inst) {
                        setTimeout(function () {
                            var rect = input.getBoundingClientRect();
                            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                            var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

                            inst.dpDiv.css({
                                top: rect.top + scrollTop - inst.dpDiv.outerHeight() - 10,
                                left: rect.left + scrollLeft,
                                position: 'absolute'
                            });
                        }, 0);
                    },
                });

                $input.addClass('hasDatepicker');
            }

            // $input.datepicker("refresh");

            // Ensure datepicker opens on focus
            $input.on('focus', function () {
                jQ(this).datepicker('show');
            });

            // Ensure datepicker opens on click, even if already focused
            $input.on('click', function () {
                jQ(this).datepicker('show');
            });

            // Adjust Datepicker position on scroll
            jQ(window).on('scroll', function () {
                if ($input.datepicker('widget').is(':visible')) {
                    $input.datepicker('hide').datepicker('show');
                }
            });

            if (maxDate) {
                $input.attr('max_date', maxDate);
                $input.datepicker('option', {maxDate: maxDate});
            }

            if (closedDays || closedDates) {
                var days = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
                $input.datepicker('option', {
                    beforeShowDay: function (date) {
                        var day = days[date.getDay()];
                        var formattedDate = jQ.datepicker.formatDate('mm/dd/yy', date);

                        if (closedDays.indexOf(day) !== -1) {
                            return [false, ''];
                        }
                        if (closedDates.indexOf(formattedDate) !== -1) {
                            return [false, ''];
                        }
                        return [true, ''];
                    }
                });
            }
        });
    }
    else {
        jQ('.st_unit_size_table', parent).css('display', '');
        jQ('#desc_reserv_' + id, parent).css('display', 'none');
        jQ('.reserve_form_container', parent).css('display', 'none');
    }
    return false;
}
